import React from 'react';
import {useTranslation} from "react-i18next";

const ListDetailsOrder = ({ order }) => {
    const { t } = useTranslation()

    return (
        <div className="py-2 align-middle inline-block min-w-full px-2 mb-2">
            <div className=" overflow-hidden border-b border-gray-200 ">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                    <tr>
                        <th scope="col"
                            className="pl-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            {t('QTY')}
                        </th>
                        <th scope="col"
                            className="pl-2 py-1 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            {t('Item')}
                        </th>
                    </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                    {order.items && order.items.map((item) => {
                        return (
                            <React.Fragment key={item.id}>
                                <tr>
                                    <td className="pl-2 py-1 whitespace-nowrap">
                                        <div className="text-sm text-gray-900">
                                            {item.amount}
                                        </div>
                                    </td>
                                    <td className="py-1">
                                        <div className="flex items-center ml-2">
                                            <div className="text-md font-bold text-gray-900">
                                                {item.name}
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                                {item.modifiers && item.modifiers.map((mod) => (
                                    <tr className="" key={mod.id}>
                                        <td className="pl-2 py-2 whitespace-nowrap">
                                            <div className="text-sm text-gray-900">
                                                {item.amount}
                                            </div>
                                        </td>
                                        <td className="py-2">
                                            <div className="flex items-center ml-6">
                                                <div className="font-medium text-sm text-gray-900">
                                                    {mod.name}
                                                </div>
                                            </div>
                                        </td>

                                    </tr>
                                ))}
                            </React.Fragment>
                        )
                    })}
                    </tbody>

                </table>
            </div>

        </div>
    )
}

export default ListDetailsOrder;
